var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page container"},[_c('div',{staticClass:"col-md-8"},[_c('h3',[_vm._v("404 ошибка")]),_vm._v(" "),_c('p',[_vm._v("Неправильно набран адрес, или такой страницы больше не существует.")]),_vm._v(" "),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Вернуться на главную.")])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4da4c6f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ErrorPage.vue
// module id = 8ZoY
// module chunks = 0